import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("germac_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("germac_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const can = (user, action) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const map = {
    create_product: ["magazziniere", "ufficio_acquisti"],
    edit_product: ["magazziniere", "ufficio_acquisti"],
    delete_product: [],
    carico: ["magazziniere", "ufficio_acquisti"],
    scarico: ["magazziniere", "meccanico"],
    rettifica: ["magazziniere"],
    manage_users: [],
  };
  return (map[action] || []).includes(user.role);
};
